// Park money: our own money on screen. The engine, the api and the database count coins; the screen
// shows 1 coin as ₦100 with the word "park money", so it never reads as Lagos Life's fare (which is
// always labelled "fare"). Park money is written short: ₦500, ₦1k, ₦2.5k, ₦10k, ₦1.2M (at most one
// decimal, never a trailing .0). Fare keeps plain digits ("₦1,000"), the way the platform's sheet shows it.

/** How many park naira one coin shows as. */
export const NAIRA_PER_COIN = 100;

/** Naira in shorthand: 950 -> "₦950", 1,500 -> "₦1.5k", 10,000 -> "₦10k", 2,500,000 -> "₦2.5M". */
export function shortNaira(naira: number): string {
  const n = Math.round(Math.abs(naira || 0));
  const sign = naira < 0 && n > 0 ? '-' : '';
  if (n < 1000) return `${sign}₦${n}`;
  const k = Math.round(n / 100) / 10;
  if (k < 1000) return `${sign}₦${k}k`;
  const m = Math.round(n / 100_000) / 10;
  return `${sign}₦${m}M`;
}

/** A coin amount as park naira: 24 coins -> "₦2.4k". */
export const parkNaira = (coins: number): string => shortNaira(Math.round(coins || 0) * NAIRA_PER_COIN);
